<template>
  <div>
    <v-card elevation="0">
      <v-card-text>
        <form>
          <v-layout wrap>
            <v-flex xs12 sm4>
              <div class="form-control pa-1" :class="{ 'has-error': errors.has('beacon_id') }">
                <label
                  >Beacon ID
                  <template v-if="type === 'add'">
                    <v-modal-help :size="'1em'" style="font-size: 17px">
                      <div slot="body">
                        <v-card-text>
                          <div class="primary--text mb-2">Beacon ID คือ</div>
                          <p style="color: black">
                            เลขรหัสด้านหลังตัวบีคอนของคุณ เช่น HWID : 000006666e ดังนั้น Beacon ID
                            คือ 000006666e
                          </p>
                        </v-card-text>
                      </div>
                    </v-modal-help>
                  </template>
                </label>
                <input
                  v-model="beaconData.beacon_id"
                  v-validate="{ required: true, length: 10, alpha_num: true }"
                  :data-vv-as="$t('Beacon ID')"
                  name="beacon_id"
                  class="form-control"
                  type="text"
                  :disabled="type === 'edit'"
                  maxlength="10"
                />
                <span v-if="errors.has('beacon_id')" class="text-error">
                  <template v-if="errors.firstRule('beacon_id') === 'length'">{{
                    $t('error_msg_beacon_length')
                  }}</template>
                  <template v-else-if="errors.firstRule('beacon_id') === 'alpha_num'">{{
                    $t('error_msg_beacon_alpha_num')
                  }}</template>
                  <template v-else-if="errors.firstRule('beacon_id') === 'required'">{{
                    $t('error_msg_beacon_required')
                  }}</template>
                </span>
              </div>
            </v-flex>
            <v-flex xs12 sm4>
              <div class="form-control pa-1" :class="{ 'has-error': errors.has(`name`) }">
                <label>{{ $t('name') }}</label>
                <input
                  v-model="beaconData.name"
                  v-validate="'required'"
                  :data-vv-as="$t('name')"
                  :name="`name`"
                  class="form-control mr-3"
                  type="text"
                />
                <span v-if="errors.has(`name`)" class="text-error">{{ errors.first(`name`) }}</span>
              </div>
            </v-flex>
            <v-flex xs12 sm4>
              <div class="form-control pa-1" :class="{ 'has-error': errors.has(`location`) }">
                <label>{{ $t('location') }}</label>
                <input
                  v-model="beaconData.location"
                  v-validate="'required'"
                  :data-vv-as="$t('location')"
                  :name="`location`"
                  class="form-control mr-3"
                  type="text"
                />
                <span v-if="errors.has(`location`)" class="text-error">{{
                  errors.first(`location`)
                }}</span>
              </div>
            </v-flex>
            <v-flex xs12 sm12>
              <div class="form-control pa-1">
                <label>{{ $t('Tag') }}</label>
                <tags
                  v-model="beaconData.tag"
                  style="margin-bottom: 5px"
                  :tags="tagItems"
                  :btn-text="$t('Add')"
                  :data-vv-as="$t('Tag')"
                  @tags-changed="
                    (newTags) => {
                      tagItems = newTags
                    }
                  "
                  @before-adding-tag="checkTag($event)"
                ></tags>
              </div>
            </v-flex>
          </v-layout>
          <div class="text-xs-center">
            <v-btn outline color="grey" @click="$emit('onCancel')">{{ $t('cancel') }}</v-btn>
            <v-btn depressed color="primary" @click="handleSaveBeacon()">{{ $t('Save') }}</v-btn>
          </div>
        </form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Tags from '@/components/elements/Tags'

export default {
  components: {
    Tags
  },
  props: ['value', 'type'],
  data() {
    return {
      beaconData: {
        beacon_id: '',
        name: '',
        location: '',
        tag: ''
      },
      errorTag: []
    }
  },
  computed: {
    tagItems: {
      get() {
        const vm = this
        let result = []

        if (vm.beaconData && vm.beaconData.tag && vm.beaconData.tag !== '') {
          const tags = vm.beaconData.tag.split(',')

          if (tags) {
            tags.map((tag) => {
              result.push({ text: tag })
            })
          }
        }
        return result
      },
      set(value) {
        const vm = this
        let result = []

        if (value) {
          value.map(function (tag) {
            result.push(tag.text)
          })
        }
        vm.beaconData.tags = result.join(',')
      }
    }
  },
  mounted() {
    if (this.value) {
      this.beaconData = this.value
    }
  },
  methods: {
    async handleSaveBeacon() {
      const vm = this
      try {
        const result = await this.$validator.validateAll()

        if (result) {
          vm.$emit('onSave', this.beaconData)
        }
      } catch (error) {
        console.error(error)
      }
    },

    checkTag(obj) {
      this.errorTag = []
      if (obj.tag.text.length > 100) {
        this.errorTag.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/Beacon/BeaconManage.vue